<template>
  <div class="indexPageBox">
    <div class="bannerBox1">
      <HeaderCom></HeaderCom>
      <div style="height: 520px">
        <div class="banner_item" style="background-image: url('static/image/sr_banner.png');">
          <div class="banner_item1_content">
            <p>“安全管理”安责通系统</p>
            <p class="txt1">
              坚持公开透明，实行“智慧消防”“阳光消防”通过消防微信公众号
              系统对随机抽查事项、程序和结果进行实时动态的公开
            </p>
            <div class="item1_infoBox sr_btn">
              立即申请
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part1Box">
      <div class="part1_content">
        <div class="part1_header">
          <span>方案背景</span>
          <span>切实落实单位安全生产主体责任</span>
        </div>
        <div class="part1_section">
          <div>
            <span>“安责通”安全管理系统</span>
            <span></span>
            <span>企业集团为多层次的组织结构，结构层次复杂，管理难度高，往往存在信息管理和协同上的不足</span>
          </div>
          <div>
            <img src="static/image/sr_background.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="part1Box2">
      <div class="part1_item">
        <div class="part1_itemBox1">
          <div class="part1_itemBox_bg1" style="background-image: url('static/image/sr_number.png')">01</div>
          <span class="part1Box2_txt1">各块工作涉及到的责任范围信息一般沉淀在下属单位的业务部门，集团部门需要相关信息时再询问联系；</span>
        </div>
        <div class="part1_itemBox1">
          <div class="part1_itemBox_bg1" style="background-image: url('static/image/sr_number.png')">02</div>
          <span class="part1Box2_txt1">集团和下属各部门之间这些信息仍停留在条线管理程度上，缺乏综合统一的信息管理系统；</span>
        </div>
        <div class="part1_itemBox1">
          <div class="part1_itemBox_bg1" style="background-image: url('static/image/sr_number.png')">03</div>
          <span class="part1Box2_txt1">管理手段目前还是excel表格管理， 缺乏系统性、可追溯， 一是容易造成范围模糊， 盲区等问题， 二是信息靠人记，跟人跑，出现人员调岗后，信息链也就出现混乱；</span>
        </div>
        <div class="part1_itemBox1">
          <div class="part1_itemBox_bg1" style="background-image: url('static/image/sr_number.png')">04</div>
          <span class="part1Box2_txt1">信息更新没有系统化、统一规范的要求。</span>
        </div>
      </div>
    </div>
    <div class="part2Box">
      <div class="part2_content">
        <div class="part2_header">
          <span class="part2_header_txt1">方案简介</span>
          <span class="part2_header_txt2">切实落实单位安全生产主体责任</span>
          <span class="part2_header_txt3">帮助大型企业集团、园区管委会、行业主管部门(集团)切实落实单位安全生产主体责任，帮助集团领导及各级安全管理人员履职留痕、尽职免责。通过建立集团安全生产、综合整治管理信息系统，整体解决集团及下属各单位安全生产和综合整治的各项工作的信息化管理和基础管理台账资料的电子化，并辅助基本的统计、报表分析功能，提高集团公司和下属各单位安全生产和综合整治的信息化整体管理水平，提升管理效率，强化管理手段，强调安全生产预控管理。</span>
        </div>
      </div>
    </div>
    <div class="part4Box">
      <div class="part4_content">
        <div class="part4_header">
          <span class="part2_header_txt1">解决方案</span>
          <span class="part4_header_txt1">切实落实单位安全生产主体责任</span>
        </div>
        <div class="part3_tab_contentTxt1">
          <div>
            <span class="part3_squ"></span>
          </div>
          <span>主要实现责任范围管理、安全生产管理、隐患综合治理、一张图预警和综合管理等功能。其中安全生产管理又包括目标管理、管理架构、专项工作落实、安全生产责任制、领导责任落实、安全检查、宣传培训、设备管理、安全生产投入、职业卫生健康等功能。隐患综合治理包括隐患台帐、隐患随手拍、整改派单、现场整改、整改审核和闭环存档。</span>
        </div>
        <div>
          <img src="static/image/sr_programme.png" alt="">
        </div>
      </div>
    </div>
    <div class="part4Box">
      <div class="part4_content">
        <div class="part4_header">
          <span class="part2_header_txt1">客户案例</span>
          <span class="part4_header_txt1">切实落实单位安全生产主体责任</span>
        </div>
        <div class="part3_tab_contentTxt1 part3_space">
          <div>
            <span class="part3_squ"></span>
          </div>
          <span class="part3_txt1">嘉兴市城市投资发展集团有限公司</span>
        </div>
        <div class="part3_tab_contentTxt1">
          <span>嘉兴市城市投资发展集团有限公司是嘉兴市政府直属的城建投资型国有企业集团，公司注册资本20.亿元，拥有国有资产总额146亿元，国有资产净额约55亿元，拥有事业单位、全资、控股承资企业12家。主要涉及建设、有机更新、旅游、天然气4大板块，涉及到市政、房建、绿化建设，征迁及地块管理；纪念馆、景区、街区管理，天然气管网建设及运行，物业小区管理、资产出租、农贸市场管理，还有未移交道路管养、河道保洁等等。嘉兴市嘉诚建设发展有限公司嘉兴市嘉城防屋拆迁有限公司嘉兴市天然气管网建设管理有限公司</span>
        </div>
        <div class="part4_content2">
          <div class="part4_content2_item1">
            <img src="static/image/sr_company.png" alt="">
          </div>
          <div>
            <div class="part4_content2_item2 part4_content2_item2Color">
              嘉兴市嘉城建设发展有限公司
            </div>
            <div class="part4_content2_item2">
              嘉兴市嘉城防屋拆迁有限公司
            </div>
            <div class="part4_content2_item2">
              嘉兴市天然气管网建设管理有限公司
            </div>
            <div class="part4_content2_item2">
              嘉兴市燃气集团有限公司
            </div>
            <div class="part4_content2_item2">
              嘉兴市旅游发展有限公司
            </div>
            <div class="part4_content2_item2">
              嘉兴市沙龙国际宾馆有限公司
            </div>
          </div>
        </div>
        <div class="part4_content3">
          <div class="part4_header">
            <span class="part2_header_txt1">系统界面</span>
            <span class="part4_header_txt1">切实落实单位安全生产主体责任</span>
          </div>
          <div>
            <img src="static/image/sr_programme.png" alt="">
          </div>
          <div class="part4_content3_space">
            <div class="part4_content3_bgBox" style="background-image: url('static/image/sr_box.png')">
              <span class="part4_content3_txt1">01</span>
              <span class="part4_content3_txt2">责任范围信息话管理，动态更新</span>
            </div>
            <div class="part4_content3_bgBox2">
              <span class="part1Box2_txt1">实现集团公司管理范围信息数据库管理，责任范围、资产项目、建设项目信息动态更新，查询信息更便捷，效率更高</span>
            </div>
          </div>
          <div class="part4_content3_space">
            <div class="part4_content3_bgBox" style="background-image: url('static/image/sr_box.png')">
              <span class="part4_content3_txt1">02</span>
              <span class="part4_content3_txt2">安全生产信息化管理，统一化、规范化</span>
            </div>
            <div class="part4_content3_bgBox2">
              <span class="part1Box2_txt1">实现集团公司及下属各单位安全生产目标工作管理、安全责任制落实、安全检查、隐患管理、应急管理、设备管理、安全投入等系统化管理，以及基础台账资料的电子化、统一化、规范化。</span>
            </div>
          </div>
          <div class="part4_content3_space">
            <div class="part4_content3_bgBox" style="background-image: url('static/image/sr_box.png')">
              <span class="part4_content3_txt1">03</span>
              <span class="part4_content3_txt2">综合整治管理，流程闭环</span>
            </div>
            <div class="part4_content3_bgBox2">
              <span class="part1Box2_txt1">系统可通过第三方系统(对接系统：数字城管、110等)、综合整治来电来函、检查情况、随手拍等收集综合整治案件，实现任务的接收、整改、结果回复的流程闭环。</span>
            </div>
          </div>
          <div class="part4_content3_space">
            <div class="part4_content3_bgBox" style="background-image: url('static/image/sr_box.png')">
              <span class="part4_content3_txt1">04</span>
              <span class="part4_content3_txt2">协同办公，提高沟通效率</span>
            </div>
            <div class="part4_content3_bgBox2">
              <span class="part1Box2_txt1">提供集团公司统一信息沟通系统，比如：下发通知公告、综合整治日常文件传阅、报表报送等，沟通效率明显提高。</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part5Box" style="background-image: url('static/image/sr_advantage.png')">
      <div class="part5_content">
        <div class="part5_header">
          <p class="part5_txt1">系统优势</p>
          <p class="part5_txt2">切实落实单位安全生产主体责任</p>
        </div>
      </div>
    </div>
    <RegisterCom></RegisterCom>
    <FooterCom></FooterCom>
  </div>
</template>

<script>
  import HeaderCom from "../common/headerCom"
  import FooterCom from "../common/footerCom"
  import RegisterCom from "../common/registerCom"
  export default {
    name: "safetyResponsibility",
    components: {HeaderCom, FooterCom,RegisterCom},
    data(){
      return{

      }
    },
    methods: {

    }
  }
</script>

<style scoped>
  @import  '../../assets/css/bannerCom.css';
  .part1Box{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
  }
  .sr_btn{
    background:rgba(42,86,239,1);
  }
  .part1_content{
    width: 1200px;
    height: 630px;
    box-sizing: border-box;
    padding: 60px 0 0 0;
  }
  .part1Box2{
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .part1_item{
    width: 1200px;
    box-sizing: border-box;
  }
  .part1_itemBox1{
    width: 100%;
    display: flex;
    box-sizing: border-box;
    padding: 30px 0;
  }
  .part1_itemBox_bg1{
    width: 104px;
    height: 60px;
    font-size:20px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(40,52,87,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 15px 0 0 18px;
  }
  .part1Box2_txt1{
    display: inline-block;
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 15px 0 0 10px;
  }
  .part1_header{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .part1_header>span:nth-of-type(1){
    font-size:28px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(40,52,87,1);
  }
  .part1_header>span:nth-of-type(2){
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(143,149,169,1);
    box-sizing: border-box;
    padding: 30px 0 80px 0;
  }
  .part1_section{
    width: 100%;
    height: 300px;
    box-sizing: border-box;
    display: flex;
  }
  .part1_section>div:nth-of-type(1){
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .part1_section>div:nth-of-type(1)>span:nth-of-type(1){
    font-size:20px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(40,52,87,1);
    line-height:30px;
  }
  .part1_section>div:nth-of-type(1)>span:nth-of-type(2){
    width:30px;
    height:3px;
    background:rgba(42,98,255,1);
    box-sizing: border-box;
    margin: 30px 0;
  }
  .part1_section>div:nth-of-type(1)>span:nth-of-type(3){
    width: 519px;
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
    box-sizing: border-box;
  }
  .part1_section>div:nth-of-type(2){
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: right;
  }
  .part2Box{
    width:100%;
    background:rgba(238,242,254,1);
    display: flex;
    justify-content: center;
  }
  .part2_content{
    width: 1200px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .part2_header{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    padding: 65px 0 0 0;
    flex-direction: column;
    align-items: center;
  }
  .part4_header{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  .part2_header_txt1{
    font-size:28px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(40,52,87,1);
  }
  .part2_header_txt2{
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(143,149,169,1);
    box-sizing: border-box;
    padding: 20px 0 55px 0;
  }
  .part2_header_txt3{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 0 0 60px 0;
  }
  .part4Box{
    width: 100%;
    display: flex;
    justify-content: center;
    background: #ffffff;
    box-sizing: border-box;
    padding: 60px 0;
  }
  .part3_tab_contentTxt1{
    width: 100%;
    box-sizing: border-box;
    padding:0 0 45px 0;
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height: 30px;
    display: flex;
  }
  .part3_squ{
    display: inline-block;
    width:14px;
    height:14px;
    border:2px solid rgba(42,98,255,1);
    border-radius:50%;
    box-sizing: border-box;
    margin: 10px 10px 0 0;
  }
  .part3_txt1{
    color: rgba(42,98,255,1);
    padding: 3px 0 0 0;
  }
  .part3_space{
    padding: 20px 0 30px 0;
  }
  .part4_content2{
    width: 1200px;
    box-sizing: border-box;
    display: flex;
  }
  .part4_content2_item2{
    width:450px;
    height:64px;
    border:1px solid rgba(186,210,255,1);
    font-size:20px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(40,52,87,1);
    line-height:30px;
    margin: 0 0 26px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .part4_content2_item2Color{
    background:rgba(42,98,255,1);
    color:rgba(255,255,255,1);
  }
  .part4_content3{
    width: 1200px;
    box-sizing: border-box;
    padding: 0 100px;
  }
  .part4_content3_bgBox{
    width: 536px;
    height: 80px;
    box-sizing: border-box;
  }
  .part4_content3_txt1{
    display: inline-block;
    font-size:24px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(40,52,87,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 26px 0 0 30px;
  }
  .part4_content3_txt2{
    display: inline-block;
    font-size:18px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(42,98,255,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 0 0 0 94px;
  }
  .part4_content3_bgBox2{
    box-sizing: border-box;
    padding: 0 0 0 126px;
  }
  .part4_content3_space{
    padding: 0 0 30px 30px;
  }
  .part4_content{
    width: 1200px;
    box-sizing: border-box;
  }
  .part4_header_txt1{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(143,149,169,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 25px 0;
  }
  .part5Box{
    width: 100%;
    height: 750px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    background:rgba(18,29,61,1);
  }
  .part5_content{
    width: 1200px;
    box-sizing: border-box;
    padding: 60px 100px;
  }
  .part5_txt1{
    font-size:28px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(255,255,255,1);
    line-height:30px;
    text-align: center;
    box-sizing: border-box;
  }
  .part5_txt2{
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(143,149,169,1);
    line-height:30px;
    text-align: center;
    padding: 30px;
  }
</style>




// WEBPACK FOOTER //
// src/components/info/safetyResponsibility.vue